
const CollegeList = () => {
  return (
    <div className="container-fluid mt-1">
      {/* 🔹 Header */}
      <h6 className="fw-bold mb-3" style={{borderBottom:'2px solid #90b732', color:'#90b732', paddingBottom:'8px'}}>College List</h6>

      {/* 🔹 Filter Row */}
      <div className="border p-2 mb-2 d-flex align-items-center justify-content-between">
        <div className="fw-bold text-primary" style={{fontSize:'13px'}}>
          <i className="bi bi-funnel-fill text-dark"></i> Filters / Options
        </div>
        <div className="d-flex align-items-center">
          <input
            type="text"
            className="form-control form-control-sm me-2"
            placeholder="College"
            style={{ width: "200px" }}
          />
          <button className="btn btn-sm btn-primary">
            <i className="bi bi-search"></i>
          </button>
        </div>
      </div>

      {/* 🔹 Pagination Controls */}
      <div className="d-flex align-items-center mb-2">
        <button className="btn btn-sm btn-light me-1">&laquo;|</button>
        <button className="btn btn-sm btn-light me-1">&laquo;</button>
        <span className="me-1">Page :</span>
        <input
          type="text"
          value="1"
          readOnly
          className="form-control form-control-sm text-center me-1"
          style={{ width: "50px" }}
        />
        <span className="me-2">of 1</span>
        <button className="btn btn-sm btn-light me-1">&raquo;</button>
        <button className="btn btn-sm btn-light me-3">|&raquo;</button>

        <span className="me-1">Page Size :</span>
        <input
          type="text"
          value="10"
          readOnly
          className="form-control form-control-sm text-center"
          style={{ width: "60px" }}
        />
      </div>

      {/* 🔹 College Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-sm text-center align-middle">
          <thead>
            <tr style={{background:'#90b732', color:'#fff'}}>
              <th rowSpan="2" style={{ verticalAlign: "middle" }}>#</th>
              <th rowSpan="2" style={{ verticalAlign: "middle" }}>Name</th>
              <th colSpan="3">Fee</th>
              <th rowSpan="2" style={{ verticalAlign: "middle" }}>Location</th>
              <th rowSpan="2" style={{ verticalAlign: "middle" }}>Landline Number</th>
              <th rowSpan="2" style={{ verticalAlign: "middle" }}>Status</th>
            </tr>
            <tr style={{background:'#90b732', color:'#fff'}}>
              <th>Payable</th>
              <th>Paid</th>
              <th>Pending</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" className="text-muted fw-bold">
                No Colleges Found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CollegeList;
